import { HelperManager, helperManager } from '../utils/Helper';
import { $body, $document, $window } from '../global';
import { blockManager } from './blocks';
import { layoutManager } from './layout';
import { LoadingSpinner } from './loading-spinner';
import { mainMenuManager } from './main-menu';
import { navigationManager } from './navigation';
import { transitionendAsync } from '../utils/animation';
import { setTimeoutAsync } from '../utils/timeout';
import { VideoManager } from './video';
class OverlayManager {
    overlayCompensation = 1;
    lazyloadFailedText;
    lazyloadRetryBtnText;
    isNavigating = false;
    loadingSpinner;
    busy = false;
    constructor() {
        this.lazyloadFailedText = $body.data('overlay-lazyload-failed-text') || 'Het is niet gelukt om de inhoud te laden. Controleer je internetverbinding en probeer het opnieuw';
        this.lazyloadRetryBtnText = $body.data('overlay-lazyload-retry-btn-text') || 'Opnieuw proberen';
        const overlay = $('.Overlay-Visible');
        if (overlay.length)
            this.prepareOverlay(overlay);
        window.addEventListener('popstate', () => {
            this.onNavigation();
        });
    }
    _originalOverlayContainer;
    get originalOverlayContainer() {
        if (!this._originalOverlayContainer) {
            this._originalOverlayContainer = $('.js-OriginalOverlayContainer').length ? $('.js-OriginalOverlayContainer') : $('<div class="js-OriginalOverlayContainer"></div>');
        }
        return this._originalOverlayContainer;
    }
    _emptyOverlay;
    get emptyOverlay() {
        if (!this._emptyOverlay)
            this._emptyOverlay = $('<div class="EmptyOverlay"></div>');
        return this._emptyOverlay;
    }
    get overlayMargin() {
        return mainMenuManager.isMobileMenu() ? 70 : 140;
    }
    attachEmptyOverlay() {
        $body.append(this.emptyOverlay);
    }
    detachEmptyOverlay() {
        this.emptyOverlay.remove().removeAttr('style');
    }
    onNavigation() {
        if (this.busy || this.checkAndSetNavigating())
            return;
        const url = navigationManager.getLocationUrl();
        if (url) {
            const overlay = $(`.Overlay[data-url="${url}"]:not(.Overlay-Visible)`);
            if (overlay.length) {
                if (!navigationManager.shouldRevertNavigation(1, url))
                    navigationManager.setUrl(1, true, url, overlay.data('title'));
                else
                    navigationManager.setUrl(-1, true);
                this.openWithGridItemCheck(overlay);
                return;
            }
        }
        const overlay = $(`.Overlay-Visible:not([data-url="${url}"])`);
        if (!overlay.length) {
            // if(url == $body.data('url') || $(`[href="${url}"]`).length)
            return;
            // This is not an overlay url or page url. Might be a zorgpad navigation event
            // location.reload(true);
        }
        if (!navigationManager.shouldRevertNavigation(-1, url))
            navigationManager.setUrl(-1, true);
        else
            navigationManager.setUrl(1, true, url, $body.data('title'));
        this.close(overlay);
    }
    openWithGridItemCheck(overlay) {
        if (overlay.closest('.js-GridItem').length) {
            blockManager.open(overlay[0]);
        }
        else {
            this.open(overlay);
        }
    }
    async open(overlay, delegate = null, coveredOriginalFrameCallback = null) {
        if (this.busy)
            return false;
        this.busy = true;
        const isNavigating = this.checkAndSetNavigating();
        const url = overlay.data('url');
        if (!isNavigating && url) {
            if (!navigationManager.shouldRevertNavigation(1, url)) {
                const title = overlay.data('title');
                navigationManager.setUrl(1, false, url, title);
            }
            else {
                navigationManager.setUrl(-1, false, null, null);
            }
        }
        let originalFrame;
        if (overlay.closest('.js-GridItem, .js-Timetable-Activity').length) {
            this.originalOverlayContainer.insertAfter(overlay);
            overlay.addClass('Overlay-Has-Original-Container');
            originalFrame = this.getFrame(this.originalOverlayContainer);
        }
        this.lazyload(overlay, delegate);
        const emptyOverlay = this.emptyOverlay;
        if (originalFrame) {
            emptyOverlay.css({
                left: originalFrame.left,
                top: originalFrame.top,
                width: originalFrame.width,
                height: originalFrame.height
            });
        }
        else {
            this.setEmptyOverlayDefaultStartPoint(emptyOverlay, overlay);
        }
        $body.append(overlay);
        this.attachEmptyOverlay();
        await setTimeoutAsync(1); // Wait for attachment before awaiting transitions
        const overlayContentWrapper = overlay.find('.Overlay_ContentWrapper');
        let emptyOverlayTransitionEnd = transitionendAsync(emptyOverlay);
        overlay.removeClass('Overlay-Hidden');
        emptyOverlay.addClass('EmptyOverlay-Visible').addClass('EmptyOverlay-Zoomed');
        if (originalFrame) {
            // Wait for the empty overlay to cover the block
            await emptyOverlayTransitionEnd;
            if (coveredOriginalFrameCallback) {
                coveredOriginalFrameCallback();
            }
        }
        emptyOverlayTransitionEnd = transitionendAsync(emptyOverlay);
        overlay.addClass('Overlay-BGVisible');
        this.matchOverlay(emptyOverlay, overlayContentWrapper, true);
        await this.resizeContent();
        await emptyOverlayTransitionEnd;
        emptyOverlayTransitionEnd = transitionendAsync(emptyOverlay);
        overlay.addClass('Overlay-Visible').removeClass('Overlay-BGVisible');
        emptyOverlay.removeClass('EmptyOverlay-Visible').removeClass('EmptyOverlay-Zoomed');
        layoutManager.hideScrollbar();
        await emptyOverlayTransitionEnd;
        await this.prepareOverlay(overlay, delegate);
        this.detachEmptyOverlay();
        this.busy = false;
    }
    async prepareOverlay(overlay, delegate = null) {
        overlay
            .find('.Overlay_CloseBtn')
            .attr('onclick', 'return false;')
            .on('click', () => {
            this.close(overlay, delegate);
        });
        const { accordionManager } = await import('./accordion');
        accordionManager.init();
        this.addTouchHandler(overlay, delegate);
    }
    checkAndSetNavigating() {
        if (this.isNavigating)
            return true;
        this.isNavigating = true;
        setTimeout(() => {
            this.isNavigating = false;
        }, 1);
        return false;
    }
    async close(overlay, delegate = null, swipedOut = false) {
        if (this.busy)
            return;
        this.busy = true;
        const isNavigating = this.checkAndSetNavigating();
        const url = overlay.data('url');
        if (!isNavigating && url) {
            if (!navigationManager.shouldRevertNavigation(-1)) {
                navigationManager.setUrl(-1, false);
            }
            else {
                const bodyUrl = $body.data('url');
                const bodyTitle = $body.data('title');
                navigationManager.setUrl(1, false, bodyUrl, bodyTitle);
            }
        }
        overlay.find('.Overlay_CloseBtn').off('click');
        this.removeTouchHandler(overlay);
        // types of close animations:
        // - Swipe up or down
        // - Resize to Block
        // - Resize to Window center
        let emptyOverlay;
        let overlayContentWrapper;
        if (!swipedOut) {
            emptyOverlay = this.emptyOverlay;
            overlayContentWrapper = overlay.find('.Overlay_ContentWrapper');
            this.matchOverlay(emptyOverlay, overlayContentWrapper, true);
            this.attachEmptyOverlay();
            const emptyOverlayTransition = emptyOverlay.css('transition');
            emptyOverlay.css('transition', 'none');
            this.matchOverlay(emptyOverlay, overlayContentWrapper);
            await setTimeoutAsync(1);
            emptyOverlay.css('transition', emptyOverlayTransition);
            // Fade in empty overlay
            emptyOverlay.addClass('EmptyOverlay-Visible');
            await transitionendAsync(emptyOverlay);
            // await setTimeoutAsync(500);
        }
        else {
            // await setTimeoutAsync(100);
        }
        overlay.removeClass('Overlay-Visible');
        if (!layoutManager.webPage.hasClass('IsActive')) {
            layoutManager.showScrollbar();
        }
        let targetFrame;
        if (overlay.hasClass('Overlay-Has-Original-Container')) {
            targetFrame = this.getFrame(this.originalOverlayContainer);
            overlay.removeClass('Overlay-Has-Original-Container');
            if (!delegate)
                delegate = blockManager.getBlock(this.originalOverlayContainer[0]);
        }
        // Resize animation
        if (!swipedOut) {
            if (targetFrame) {
                overlayContentWrapper.css({
                    transform: '',
                    left: '',
                    top: '',
                    width: '',
                    height: ''
                });
                emptyOverlay.css({
                    left: targetFrame.left,
                    top: targetFrame.top,
                    width: targetFrame.width,
                    height: targetFrame.height
                });
                await transitionendAsync(emptyOverlay);
            }
            else {
                this.setEmptyOverlayDefaultStartPoint(emptyOverlay, overlay);
                // Don't wait for the animation to complete. Animate together with the fade out animation
            }
        }
        if (delegate) {
            delegate.onClose(1);
        }
        // Fade out empty overlay
        if (!swipedOut) {
            emptyOverlay.removeClass('EmptyOverlay-Visible');
            await transitionendAsync(emptyOverlay);
            this.detachEmptyOverlay();
        }
        if (targetFrame) {
            VideoManager.disableVideosAutoplay(overlay);
            overlay.addClass('Overlay-Hidden')
                .insertAfter(this.originalOverlayContainer);
            this.originalOverlayContainer.remove();
        }
        else {
            overlay.remove();
        }
        this.busy = false;
    }
    setEmptyOverlayDefaultStartPoint($emptyOverlay, $overlay) {
        const $overlayContent = $overlay.find('.Overlay_ContentWrapper');
        const isVisible = !!$overlayContent.offset().left;
        const windowWidth = $window.width();
        const windowHeight = $window.height();
        const newWidth = isVisible ? $overlayContent.outerWidth(false) - 60 : 300;
        const newHeight = isVisible ? $overlayContent.outerHeight(false) - 60 : 150;
        $emptyOverlay.css({
            left: windowWidth / 2 - newWidth / 2,
            top: windowHeight / 2 - newHeight / 2,
            width: newWidth,
            height: newHeight
        });
    }
    matchOverlay(resize, match, calcScrollbar = false) {
        resize.css({
            transform: 'scale(1)',
            left: match.offset().left + (calcScrollbar ? layoutManager.getScrollBarWidth() / 2 : 0),
            top: this.overlayMargin,
            width: match.outerWidth(),
            height: match.outerHeight()
        });
    }
    addTouchHandler(overlay, delegate = null) {
        helperManager.disableBodyScrolling();
        const onClose = (swipedOut = false) => {
            this.close(overlay, delegate, swipedOut);
        };
        const onClosing = () => {
            overlay.off('mousedown');
        };
        overlayOverscrollManager.add(overlay, onClosing, onClose);
        overlay.on('mousedown', (e) => {
            const content = overlay.children('.Overlay_ContentWrapper');
            if ($.contains(content[0], e.target) || e.target === content[0])
                return; // Detect click outside
            if (window.innerWidth - e.clientX < 20)
                return; // Prevent closing when clicking the scrollbar
            onClose();
        });
        $document.on('keyup', (e) => {
            if (e.keyCode !== 27)
                return;
            onClose();
        });
    }
    removeTouchHandler(overlay) {
        overlayOverscrollManager.remove(overlay);
        $document.off('keyup');
        if (!layoutManager.personalPage.hasClass('IsActive'))
            HelperManager.enableBodyScrolling();
    }
    getFrame(el) {
        el = el.closest('.js-GridItem, .js-Timetable-Activity');
        if (el.length) {
            return new ElementFrame(el.offset().left - this.overlayCompensation, el.offset().top - $document.scrollTop() - this.overlayCompensation, el.outerWidth() + this.overlayCompensation * 2, el.outerHeight() + this.overlayCompensation * 2);
        }
        return null;
    }
    lazyload(overlay, delegate = null) {
        const lazyContent = overlay.find('.js-LazyOverlayContent');
        if (!lazyContent.length)
            return;
        const alwaysRefresh = !!lazyContent.data('always-refresh');
        const loaded = !!lazyContent.hasClass('.Loaded');
        if (!alwaysRefresh && loaded)
            return;
        const src = lazyContent.data('src');
        if (!src)
            return;
        lazyContent.empty();
        // Todo: Show loading animation
        if (!this.loadingSpinner)
            this.loadingSpinner = new LoadingSpinner();
        this.loadingSpinner.html.remove();
        this.loadingSpinner.html.insertBefore(lazyContent);
        this.loadingSpinner.show(500);
        $.ajax({
            url: src,
            success: (data) => {
                lazyContent.html(data);
                if (delegate && delegate.lazyLoaded)
                    delegate.lazyLoaded();
            },
            error: () => {
                // lazyContent.css('height', lazyContent.height());
                lazyContent.html(`<div class="Overlay_Content-Centered"><p>${this.lazyloadFailedText}</p><button class="Btn Btn-Default js-RetryBtn">${this.lazyloadRetryBtnText}</button></div>`);
                // lazyContent.animate({ 'height': lazyContent[0].scrollHeight });
                const $retryBtn = lazyContent.find('.js-RetryBtn');
                $retryBtn.on('click', () => {
                    this.lazyload(overlay, delegate);
                });
            },
            complete: () => {
                this.loadingSpinner.hide();
            }
        });
        // todo: ajax load content
    }
    async resizeContent() {
        const chartsManager = (await import('./charts')).chartsManager;
        chartsManager.resize();
    }
}
class ElementFrame {
    left;
    top;
    width;
    height;
    constructor(left, top, width, height) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
}
class OverlayOverscrollManager {
    shouldClose = false;
    startTouchY = 0;
    startScrollY = 0;
    prevTranslateY = 0;
    contentHeight = 0;
    scrollHeight = 0;
    isSafari = HelperManager.isSafari();
    add(overlay, onClosing, onClose) {
        // $('.console').remove();
        // $('<div class="console" style="pointer-events: none; position: fixed; z-index: 100000; right: 0; top: 0; background: #fdd;"></div>').appendTo('body');
        const content = overlay.children('.Overlay_ContentWrapper');
        content.css({
            transform: 'translateX(0)',
            'will-change': 'transform'
        });
        overlay.on('touchstart.noPreventDefault', (e) => {
            const touch = e.originalEvent.changedTouches[0];
            this.shouldClose = false;
            if ($.contains(content[0], e.target) || e.target === content[0])
                return; // Detect touch inside
            if (window.innerWidth - touch.clientX < 20)
                return; // Prevent closing when clicking the scrollbar
            this.shouldClose = true;
        });
        overlay.on('touchend', (e) => {
            if (!this.shouldClose)
                return;
            if ($.contains(content[0], e.target) || e.target === content[0])
                return; // Detect touch inside
            this.removeTouchHandlers(overlay);
            onClose();
        });
        overlay.on('touchstart.noPreventDefault', (e) => {
            this.startTouchY = e.originalEvent.changedTouches[0].clientY;
            this.startScrollY = overlay.scrollTop();
            this.contentHeight = Math.ceil(overlay.innerHeight());
            this.scrollHeight = overlay.prop('scrollHeight');
            this.prevTranslateY = this.startTouchY;
            content.css('transition', 'none');
        });
        overlay.on('touchmove.noPreventDefault', (e) => {
            if (this.shouldClose)
                this.shouldClose = false;
            const touchY = e.originalEvent.changedTouches[0].clientY;
            const scrollY = overlay.scrollTop();
            const diffScrollY = scrollY - this.startScrollY;
            const diffTouchY = touchY - this.startTouchY;
            const translateY = diffTouchY + diffScrollY;
            const direction = touchY > this.prevTranslateY ? 1 : touchY < this.prevTranslateY ? -1 : 0;
            this.prevTranslateY = touchY; // Save value for the next touch event
            if ((scrollY <= 0 && translateY > 0) || (scrollY + this.contentHeight >= this.scrollHeight && translateY < 0)) {
                content.css('transform', `translateY(${translateY}px)`);
                if (!this.isSafari) {
                    if (e.cancelable) {
                        return false;
                    }
                    return;
                }
            }
            else if (translateY !== 0) {
                const transformY = parseInt(content.css('transform').split(',')[5]);
                if (this.isSafari && transformY !== 0) {
                    content.css('transform', 'translateY(0px)');
                }
            }
            if (e.cancelable && ((direction > 0 && scrollY <= 0) ||
                (direction < 0 && scrollY + this.contentHeight >= this.scrollHeight))) {
                return false;
            }
        });
        overlay.on('touchend', (e) => {
            const transformY = parseInt(content.css('transform').split(',')[5]);
            if (transformY > -10 && transformY < 10)
                return;
            let endY = 0;
            if (transformY > this.contentHeight / 4) {
                // Pulled down
                endY = this.contentHeight;
            }
            else if (transformY < -(this.contentHeight / 4)) {
                // Pulled up
                endY = -this.contentHeight;
            }
            if (endY !== 0) {
                this.removeTouchHandlers(overlay);
                onClosing();
            }
            content.css('transition', 'transform .25s ease-out');
            setTimeout(() => {
                content.css('transform', `translateY(${endY}px)`);
            }, 1);
            setTimeout(() => {
                content.css('transition', 'none');
                if (endY !== 0) {
                    onClose(true);
                    setTimeout(() => {
                        content.css('transform', 'translateY(0px)');
                    }, 800);
                }
            }, 300);
            if (e.cancelable) {
                return false;
            }
        });
    }
    remove(overlay) {
        this.removeTouchHandlers(overlay);
        const content = overlay.children('.Overlay_ContentWrapper');
        content.css('will-change', '');
    }
    removeTouchHandlers(overlay) {
        overlay.off('touchstart.noPreventDefault touchmove.noPreventDefault touchend mouseup');
    }
}
const overlayOverscrollManager = new OverlayOverscrollManager();
const overlayManager = new OverlayManager();
export { overlayManager };
